import axios from "axios";

const atualizarEnvelopeDocuSign = async function (bodyreq) {
  var retorno = {}

  try {
      console.log(bodyreq)
      await axios({
        method: 'post',
        url: process.env.VUE_APP_ALIANCAADM_ADESAO + '/atualizarEnvelopeDocuSign?api-key=' + process.env.VUE_APP_ALIANCAADM_ADESAO_API_KEY,
        headers: { "Content-Type": "application/json" },
        data: bodyreq
      }).then(response => {
        retorno = response.data
      })
      .catch(() => {
        retorno = undefined
      })
  } catch (e) {
    console.log(e)
  }

  return retorno
};

export default atualizarEnvelopeDocuSign;
